<script setup lang="ts">
import { onMounted } from "vue";
import { useAuthStore } from "@/stores/auth";
import { useBrandingStore } from "@/stores/branding";

const auth = useAuthStore();
const branding = useBrandingStore();

onMounted(async () => {
  // Branding is public — fetch it on boot so the login screen and sidebar
  // show the configured logo/name (defaults render meanwhile).
  branding.fetch();

  // Hydrate user on app boot if a token is present
  if (localStorage.getItem("cybro_access") && !auth.user) {
    await auth.fetchMe();
  }
});
</script>

<template>
  <RouterView />
</template>
